import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { COMMON, REPORT } from "../config/apiEndPoint";
import { GET, POST, POST_V2 } from "config/api.config";
import { resolveAsyncTeamFilterPageName } from "helpers/metadataFilterHelpers";

const normalizeSelectOptions = (payload) => {
  const list = Array.isArray(payload)
    ? payload
    : Array.isArray(payload?.data)
      ? payload.data
      : Array.isArray(payload?.records)
        ? payload.records
        : Array.isArray(payload?.rows)
          ? payload.rows
          : [];

  return list
    .map((item) => {
      const value = String(
        item?.value ?? item?.id ?? item?._id ?? item?.key ?? item?.code ?? ""
      ).trim();
      const label = String(
        item?.label ??
          item?.display ??
          item?.data ??
          item?.name ??
          item?.title ??
          value
      ).trim();
      if (!value) return null;
      return { value, label: label || value };
    })
    .filter(Boolean);
};

/** GET `common/job-category` */
export const fetchLeadsAddedJobCategoryOptions = async () => {
  try {
    const response = await GET(COMMON.JOB_CATEGORY);
    return normalizeSelectOptions(response?.data ?? response);
  } catch (error) {
    toast.error(error?.message);
    return [];
  }
};

/** POST V2 `common/team` — body `{ pageName }`. */
export const fetchLeadsAddedTeamOptions = async (pageName = "ReportFiltered") => {
  try {
    const resolvedPageName = resolveAsyncTeamFilterPageName(pageName) || pageName;
    if (!resolvedPageName) return [];
    const response = await POST_V2(COMMON.TEAM, { pageName: resolvedPageName });
    return normalizeSelectOptions(response?.data ?? response);
  } catch (error) {
    toast.error(error?.message);
    return [];
  }
};

/** POST `Report/leads-added/filter` */
export const submitLeadsAddedReportFilterData = async (data = {}) => {
  try {
    const response = await POST(REPORT.LEADS_ADDED_FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `Report/leads-added/status-candidates/filter` */
export const submitLeadsAddedStatusCandidatesFilterData = async (data = {}) => {
  try {
    const response = await POST(REPORT.LEADS_ADDED_STATUS_CANDIDATES_FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
